import { useSelector } from 'react-redux';

import { Regions } from 'shared/constants';
import { isInRegionSelector, offerSelector } from 'shared/selectors';
import { EFeaturesGroupID, IFeatures } from 'shared/types/features';
import { isSuburbanOfferFromBuilder } from 'shared/utils/suburban';

const SUBURBAN_SALE_CATEGORIES_WITHOUT_LAND = ['houseSale', 'houseShareSale', 'cottageSale', 'townhouseSale'];

export const useSuburbanTechInspectionBtn = (feature: IFeatures | null) => {
  const offer = useSelector(offerSelector);

  const isFromSuburbanBuilder = isSuburbanOfferFromBuilder(offer);
  const isSuburbanSaleCategoriesWithoutLand = SUBURBAN_SALE_CATEGORIES_WITHOUT_LAND.includes(offer.category);
  const isSuburbanAboutBuildingFeature = feature?.id === EFeaturesGroupID.AboutSuburbanBuilding;
  const isMoscowOrArea = useSelector(isInRegionSelector([Regions.Moscow, Regions.MoscowArea]));

  return (
    isSuburbanSaleCategoriesWithoutLand && !isFromSuburbanBuilder && isSuburbanAboutBuildingFeature && isMoscowOrArea
  );
};
